<template>
  <div
    :class="{'gf-company-avatar-cropper' : isVerifiedCompany, 'col-6 col-md-4 col-lg-3' : isCloud}"
  >
    <gf-image-cropper
      v-if="currentAvatar"
      :selected-image-source="currentAvatar"
      :is-rounded-crop="true"
      edit-button-icon=" gf-icon gf-icon-user-edit"
      input-name="avatarFile"
      @setDefault="setDefaultAvatar"
    />
  </div>
</template>

<script>
import CompanyService from '@shared/services/company.service';
import GfImageCropper from './GfImageCropper.vue';

export default {
  name: 'GfCompanyAvatarCropper',
  components: { GfImageCropper },
  props: {
    currentAvatar: {
      type: String
    },
    isAdminVersion: {
      type: Boolean,
      default: false
    },
    companyAlias: {
      type: String
    },
    companyUuid: {
      type: String
    },
    isVerifiedCompany: {
      type: Boolean,
      default: false
    },
    isCloud: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setDefaultAvatar() {
      const setCompanyAvatar = this.isAdminVersion
        ? CompanyService.setCompanyDefaultAvatarAdmin(this.companyUuid)
        : CompanyService.setDefaultAvatar(this.companyAlias);

      setCompanyAvatar.then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="scss">
.gf-company-avatar-cropper {
  display: flex;
  justify-content: center;
  margin: -10% 0 0 40px;

  @media (max-width: 769px) {
    margin: -12% auto 0 auto;
  }
}
</style>
